import { useQuery } from '@tanstack/react-query';
import SupportWidgetKeys from '../queryKeys';
import { getAllTagsForSupportChatAPI } from '../../../api/supportChat';
import { notifyError } from '../../../utils/notify';

const { getTagsList } = SupportWidgetKeys;

const fetchTagsList = async () => {
  const { data } = await getAllTagsForSupportChatAPI();
  return data;
};

const useGetTagsListQuery = () =>
  useQuery([getTagsList], () => fetchTagsList(), {
    retry: false,
    onError: e => {
      notifyError(e, false, 'Error fetching tags list');
    },
  });

export default useGetTagsListQuery;
